import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { localeDateFormatMap, localeDateMaskMap } from 'lib/config/date-picker';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';

import deLocale from 'dayjs/locale/de';
import frLocale from 'dayjs/locale/fr';
import esLocale from 'dayjs/locale/es';
import itLocale from 'dayjs/locale/it';
import ptLocale from 'dayjs/locale/pt';

const mapNamedLocaleToDayJsLocale = {
  'motorrad-mieten': deLocale,
  'location-moto': frLocale,
  'alquiler-de-motos': esLocale,
  'noleggio-moto': itLocale,
  'aluguel-de-motos': ptLocale,
};

const LocalizedDatePicker = (props) => {
  const { className } = props;
  const appNavigator = useAppNavigator();

  useEffect(() => {
    const locale = mapNamedLocaleToLocale[appNavigator.locale]?.toLowerCase() || 'en';
    dayjs.locale(locale);
    return () => {
      dayjs.locale('en');
    };
  }, [appNavigator.locale]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={mapNamedLocaleToDayJsLocale[appNavigator.locale]}>
      <DatePicker
        format={localeDateFormatMap[appNavigator.locale]}
        mask={localeDateMaskMap[appNavigator.locale]}
        className={className}
        {...props}
      />
    </LocalizationProvider>
  );
};

export { LocalizedDatePicker };
